import { useIntl } from 'react-intl';

import { numberToOrdinal } from '@verantos-dev/shared-utils';

import type { IndexDateSelection } from '../utils/indexDateSelection';

/** Formats an index date's selection rule as a localized sentence. */
export const useIndexDateSelectionText = () => {
  const intl = useIntl();

  return (selection: IndexDateSelection | null): string | undefined =>
    selection
      ? intl.formatMessage(
          {
            id: `projects.cohortBuilder.indexDateSelection.${selection.mode}`,
          },
          {
            occurrence: selection.occurrence,
            ordinal: numberToOrdinal(selection.nthValue, intl.locale),
          }
        )
      : undefined;
};
